import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'lib/ng2-sapmp/src/providers';
import { StepIndicatorService, GridOptionsModel } from 'lib/ng2-sapmp/src/ui-components';
import { SignUpFiveGService } from '../shared/signup-fiveg.service';

@Component({
  selector: 'app-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss'],
  providers: [SignUpFiveGService]
})
export class ConfirmFivegComponent implements OnInit {
  enrolledData: any;
  isGroupBased: any;
  uploadedFileName: any = '';
  confirmAccounts: any;
  gridOptions: GridOptionsModel;

  constructor(private route: ActivatedRoute, public utilityService: UtilityService, private stepIndicatorService: StepIndicatorService, private router: Router, private signupFivegService: SignUpFiveGService) { 
    const signUpData = this.signupFivegService.getSignupData();
    if(!signUpData) {
       this.router.navigate(['/fiveg/enrollment/selectaccounts']);
    }
  }

  ngOnInit() {
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.stepIndicatorService.setCurrentStep(this.route.snapshot.url[0].path);
    this.stepIndicatorService.setVisibility(true);
    this.confirmAccounts = this.route.snapshot.data.pageData.fivegenrollmentconfirm;
    this.enrolledData = JSON.parse(sessionStorage.getItem('newFivegEnrollment'));
    // if(this.enrolledData.serviceRequested == "Account-Based") {
    //   this.isGroupBased = false;
    // }
    // else {
    //   this.isGroupBased = true;
    // }
    // this.uploadedFileName = sessionStorage.getItem('uploadedFile');
    sessionStorage.removeItem('newFivegEnrollment');
    // sessionStorage.removeItem('uploadedFile');
    let fansList = Object.keys(this.enrolledData.fanList);
    fansList.sort();
    this.confirmAccounts.grid.gridData = fansList;
    this.gridOptions = this.confirmAccounts.grid;
    this.gridOptions.gridData = this.confirmAccounts.grid.gridData;
    this.gridOptions.Paginations.totalRecords = this.gridOptions.gridData.length;
  }

  gotoDashboard() {
    this.router.navigate(['/dashboard/dep']);
  }
}
